// ** Components
import { ImageCarouselBlock } from '@/features/ap04';

// ** Utils
import { buildPathFromRelationLink } from '@/utils/ui/navigationUtils';

// ** Types
import type { ImageTeaserCardItem } from '@/components/common/ImageTeaserCard';
import type { StrapiComponentElementProps } from '@/types/strapi';
import type { ComponentBlocksCarouselBlock, UploadFile } from '@/types/graphql';

type ImageCarouselVariantProps = StrapiComponentElementProps<ComponentBlocksCarouselBlock>;

const ImageCarouselVariant = ({
	host,
	carouselCta,
	carouselShowCta,
	carouselShowTitle,
	imageCarouselImages,
	carouselSectionTitle,
	imageCarouselOnlyImages
}: ImageCarouselVariantProps) => {
	const carouselData = (imageCarouselImages ?? []).reduce<ImageTeaserCardItem[]>((acc, item) => {
		const img = item?.imageItem as UploadFile;

		if (img) {
			acc.push({
				src: undefined,
				imageData: img,
				alt: img.alternativeText || img.name || 'Carousel image',
				headline: item?.imageTitle || '',
				description: item?.imageDescription || '',
				caption: item?.imageDescription || '',
				host: host
			});
		}
		return acc;
	}, []);

	const carouselHref = carouselCta?.hrefExternal
		? carouselCta.hrefExternal
		: buildPathFromRelationLink(carouselCta?.href);

	return (
		<ImageCarouselBlock
			items={carouselData}
			showOnlyImages={imageCarouselOnlyImages}
			{...(carouselShowTitle && {
				title: carouselSectionTitle || 'Image Carousel'
			})}
			{...(carouselShowCta && {
				ctaLabel: carouselCta?.label || 'All Images',
				ctaHref: carouselHref || '#'
			})}
		/>
	);
};

export default ImageCarouselVariant;
